import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "section-customer background-grey-lighten-5 px-4 py-6 mb-4 rounded-lg" }
const _hoisted_2 = { class: "flex w-full justify-between gap-4 items-center mb-2" }
const _hoisted_3 = { class: "text-black text-xl font-bold" }
const _hoisted_4 = { class: "background-orange-lighten-5 color-primary font-bold py-2 rounded-md px-4 hidden md:flex" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "color-blue-grey font-bold" }
const _hoisted_7 = { class: "md:hidden mt-5" }
const _hoisted_8 = { class: "background-orange-lighten-5 color-primary font-bold py-2 rounded-md px-4" }
const _hoisted_9 = { class: "grid grid-cols-2 sm:grid-cols-3 gap-8 sm:gap-2 mt-6" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-sm mb-2" }, "Pengirim", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-sm mb-2" }, "Penerima", -1)
const _hoisted_12 = {
  key: 0,
  class: "col-span-2 sm:col-span-1"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-sm mb-2" }, "Pembayaran", -1)
const _hoisted_14 = { class: "flex items-center w-full lg:flex-row md:flex-col flex-row" }
const _hoisted_15 = { class: "flex items-end justify-between" }
const _hoisted_16 = { class: "action-button w-1/2 sm:w-max" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Proses & Cetak Resi")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_19 = { class: "text-right w-1/2 sm:w-max" }
const _hoisted_20 = { class: "flex items-center justify-end" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-subtitle2" }, "Grand Total", -1)
const _hoisted_22 = {
  key: 0,
  class: "rounded text-white py-1 px-3 text-xs ml-3",
  style: {"background-color":"#66BB6A"}
}
const _hoisted_23 = { class: "flex items-center justify-end" }
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "pi pi-refresh color-primary" }, null, -1)
const _hoisted_25 = { class: "font-bold color-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputText = _resolveComponent("InputText")
  const _component_ListItemsReceipt = _resolveComponent("ListItemsReceipt")
  const _component_AddOnReceipt = _resolveComponent("AddOnReceipt")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogConfirm = _resolveComponent("DialogConfirm")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$store.state.deliveryItem.dataAfterPost.KodeJadwal), 1),
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.getTextTypeDelivery()), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, _toDisplayString(`${_ctx.$store.state.appActiveUser.agent?.kotaName} (${_ctx.$store.state.appActiveUser.agent?.name}) -
          ${_ctx.$store.state.deliveryItem.toAgentName}`), 1)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.getTextTypeDelivery()), 1)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", null, [
          _hoisted_10,
          _createVNode("p", null, _toDisplayString(_ctx.$store.state['deliveryItem'].dataSender.nameSender) + " (" + _toDisplayString(_ctx.$store.state['deliveryItem'].dataSender.telpSender) + ")", 1),
          _createVNode("p", null, _toDisplayString(_ctx.$store.state['deliveryItem'].dataSender.addressSender), 1)
        ]),
        _createVNode("div", null, [
          _hoisted_11,
          _createVNode("p", null, _toDisplayString(_ctx.$store.state['deliveryItem'].dataReceiver.nameReceiver) + " (" + _toDisplayString(_ctx.$store.state['deliveryItem'].dataReceiver.telpReceiver) + ")", 1),
          _createVNode("p", null, _toDisplayString(_ctx.$store.state['deliveryItem'].dataReceiver.addressReceiver), 1)
        ]),
        (!_ctx.isMiisi)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_Multiselect, {
                  id: "paymentId",
                  class: "mr-2 lg:mb-0 mb-0 md:mb-2 text-sm flex-1 w-auto md:w-full lg:w-auto bg-white rounded-lg sm-multiselect",
                  label: "Nama",
                  trackBy: "Nama",
                  valueProp: "Id",
                  modelValue: _ctx.paymentId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.paymentId = $event)),
                  options: _ctx.listPayment,
                  placeholder: "",
                  searchable: true,
                  allowEmpty: false
                }, null, 8, ["modelValue", "options"]),
                _createVNode(_component_InputText, {
                  class: "input-primary text-sm md:w-full w-min lg:w-1/2",
                  placeholder: "Pembayaran",
                  modelValue: _ctx.paymentRef,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.paymentRef = $event)),
                  type: "text"
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ListItemsReceipt, { ref: "elListItemsReceipt" }, null, 512),
    _createVNode(_component_AddOnReceipt, { ref: "addonReceiptEl" }, null, 512),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_Button, {
          class: "btn-primary text-black mr-3 px-4 md:px-10 py-1 mb-3 sm:mb-0 text-sm md:text-base",
          disabled: _ctx.showButton,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitData()))
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Button, {
          class: "btn-secondary text-black px-4 md:px-10 py-1 text-sm md:text-base",
          disabled: _ctx.showButton,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitBack()))
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          (_ctx.Attribute3)
            ? (_openBlock(), _createBlock("div", _hoisted_22, " Lunas "))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_23, [
          _createVNode(_component_Button, {
            class: "btn-eee px-2 mr-3",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getGrandPrice()))
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }),
          _createVNode("h5", _hoisted_25, "Rp " + _toDisplayString(new Number(_ctx.grandPrice).toLocaleString('id-ID')), 1)
        ])
      ])
    ]),
    _createVNode(_component_DialogConfirm, { ref: "refDialogConfirm" }, null, 512)
  ]))
}